import { Text } from '@cheqroom/ui';
import tw, { styled } from 'twin.macro';

export const CardTag = styled(Text)`
	${tw`bg-gray-100 px-2 py-0.5 ml-4 self-start rounded-t border-t border-x border-gray-200`}
`;
